<section class="search-result-item shadow mb-5">
  <a [routerLink]="['/salon', item.salonCity, item.salonNameAlias]">
    <div class="search-result-item-container">
      <div class="salon-image-container">
        <div class="salon-image shadow-sm bg-white"
             [ngStyle]="{'background-image': 'url(' + pictureUrl + ')'}">
        </div>
        <div class="salon-logo shadow-sm bg-white"
             [ngStyle]="{'background-image': 'url(' + logoUrl + ')'}">
        </div>
      </div>
      <div class="salon-description-container d-flex align-content-between flex-wrap">
        <div class="w-100 mb-4">
          <h2 class="h4 mb-2 fw-bolder quicksand-headings-lh notranslate">{{item.salonName}}</h2>

          <div class="mb-3">
            <div *ngIf="item.reviewsCount > 0"
                 class="d-flex flex-row align-items-center mb-0">
              <span class="text-cta h6 mb-0 fw-bold me-1">{{ item.averageRating | number: '1.1-1' }}</span>
              <app-rating-stars [clickable]="false"
                                class="me-2"
                                [ratingValue]="item.averageRating"></app-rating-stars>
              <span class="text-dark h6 mb-0 fw-bold"
                    [translate]="'SALON-SEARCH-RESULTS.SALON-ITEM.TEXT-REVIEWS-COUNT'"
                    [translateParams]="{reviewsCount: item.reviewsCount}">
              </span>
            </div>
            <div class="d-flex flex-column"
                *ngIf="item.distanceFromSearchedCity">
              <a [attr.href]="googleMapsUrl"
                target="_blank"
                rel="noopener noreferrer"
                (click)="$event.stopPropagation()"
                class="d-inline-flex align-items-center text-primary">
                <span [translate]="'SALON-SEARCH-RESULTS.SALON-ITEM.DISTANCE-FROM-SEARCHED-CITY'"
                      [translateParams]="{ distanceInKm: item.distanceFromSearchedCity | number:'1.0-1':'nl', searchedCity: cityName }">
                </span>
              </a>
            </div>
          </div>

          <ng-container *ngFor="let department of item.salonDepartments; let i = index">
            {{ department.name }}
            <ng-container *ngIf="i < item.salonDepartments.length-1">, </ng-container>
          </ng-container>
          <p class="mb-0 text-secondary notranslate">{{item | salonFormattedAddress}}</p>
          <app-badge-gifts *ngIf="item.allowsGifts"
                           [enableTooltip]="true"
                           class="mb-1 me-2 mt-2"></app-badge-gifts>
        </div>
        <div class="w-100 d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <p class="mb-0 text-primary"
               *ngIf="item.distanceToSalon">{{item.distanceToSalon}} km
            </p>
            <a [attr.href]="googleMapsUrl"
               target="_blank"
               rel="noopener noreferrer"
               (click)="$event.stopPropagation()"
               class="d-inline-flex align-items-center text-secondary">
              <span [translate]="'SALON-SEARCH-RESULTS.SALON-ITEM.LINK-SEE-ON-MAP'"></span>
              <i-feather name="external-link"
                         class="sm ms-1"></i-feather>
            </a>
          </div>
          <button type="button"
                  class="btn btn-primary px-4 text-uppercase notranslate"
                  [translate]="'SALON-SEARCH-RESULTS.SALON-ITEM.BUTTON-BOOK'">
          </button>
        </div>
      </div>
    </div>
  </a>
</section>
